import React from 'react';
import { Container, Row, Col, Button, ListGroup, ListGroupItem } from 'reactstrap';
import { FaCheck } from 'react-icons/fa'; // For checkmark icons
import qRCode from "../../../assets/img/brand/SaaS_App_still_in_use_.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BsArrowLeftCircle } from "react-icons/bs";

const SubscriptionConfirmationPageContent = ({hasLicense = true }) => {
    return (
        <Container className="text-center">
            {/* Header */}
            <FaCheck size={40} color="#19aba8" />
            <h3 className="mt-3">Your portal has successfully been created!</h3>
            <p>Please check your email on a desktop device to gain access to your Portal.</p>

            {/* Checklist */}
            <div className="p-3 my-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                <h4>Let's review the final steps needed to get started.</h4>
                <ListGroup className="ml-7" flush>
                    <ListGroupItem className="d-flex align-items-center">
                        <FaCheck size={20} color="#19aba8" className="me-2" /> <span className="pl-3">Create your account <b>(DONE!)</b></span>
                    </ListGroupItem>
                    <ListGroupItem className="d-flex align-items-center">
                        <FaCheck size={20} color="#19aba8" className="me-2" /> <span className="pl-3">Build your Date Code Genie Portal <b>(DONE!)</b></span>
                    </ListGroupItem>
                    {hasLicense && <ListGroupItem className="d-flex align-items-center">
                        <FaCheck size={20} color="#19aba8" className="me-2" /> <span className="pl-3">Purchase device licenses <b>(DONE!)</b></span>
                    </ListGroupItem>}
                    <ListGroupItem className="d-flex align-items-center text-muted">
                        <FaCheck size={20} color="lightgray" className="me-2" /> <span className="pl-3">Download the Date Code Genie App on your tablet</span>
                    </ListGroupItem>
                    <ListGroupItem className="d-flex align-items-center text-muted">
                        <FaCheck size={20} color="lightgray" className="me-2" /> <span className="pl-3">Purchase your printers and labels</span>
                    </ListGroupItem>
                    {!hasLicense && <ListGroupItem className="d-flex align-items-center text-muted">
                        <FaCheck size={20} color="lightgray" className="me-2" /> <span className="pl-3">Purchase device licenses from your portal </span>
                    </ListGroupItem>}
                </ListGroup>
            </div>
            <Row className="onboarding-action-container">
                <Col xs="auto">
                    <img className="onboarding-qr-code" src={qRCode} alt="image" />
                </Col>
                <Col>
                    <Row className="onboarding-action-text">
                        Download the&nbsp;<b>DateCodeGenie App</b> on the Android or IOS tablet you plan on using to print labels.<br />
                    </Row>
                    <Row className="onboarding-action-text"> 
                        <BsArrowLeftCircle className="qr-indicator" size="19px" color="#1CABA8" /><b>&nbsp;Use tablet to scan, or search your app store.</b>
                    </Row>
                </Col>
                
            </Row>
            {/* Action Buttons */}
            <Row className="justify-content-center">
                <Col xs="auto">
                    <Button href="https://store.ncco.com/datecodegenie-mc-label3-multifunctional-printer" target="_blank" color="primary" className="me-2">Buy Compatible Printer</Button>
                </Col>
                <Col xs="auto">
                    <Button href="https://store.ncco.com/labels" target="_blank" color="primary">Shop Labels</Button>
                </Col>
            </Row>

        </Container>
    );
};

export default SubscriptionConfirmationPageContent;
